import React, { Component, useEffect, useRef } from 'react';
import ScrollMagic from 'scrollmagic';
import Proptypes from 'prop-types';
import gsap from 'gsap';
import 'react-step-progress-bar/styles.css';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { ImageLazyLoad } from '../ImageLazyLoad';
import { FullWidthContainer } from '../FullWidthContainer';
import { ProgressBar } from 'react-step-progress-bar';
import styled from 'styled-components';
import { CustomButton } from '../Buttons/';

// const FlexWrapper = styled.div`
//   /* position: absolute; */
//   /* top: 30%; */
//   /* left: 6%; */
//   /* right: 50%; */
//   /* z-index: 1; */
//   @media only screen and (max-width: 768px) {
//     /* top: 20%;
//     bottom: 50%;
//     left: 5%;
//     right: 5%; */
//     /* bottom: 20%; */
//   }
// `;

const BannerImage = styled.div`
  width: 600px;
  object-fit: contain;
  height: auto;
  margin-right: 0 40px;
  border-radius: 20px;

  .gatsby-image-wrapper {
    position: static !important;
  }
  @media only screen and (max-width: 768px) {
    /* opacity: 0.5; */
  }
  &.hideImage {
    opacity: 0;
    position: absolute;
  }
  &.parallaxImg {
    /* transform: matrix(1.2, 0, 0, 1.2, 0, ${(props) => props.transformY}); */
    /* position: absolute; */
  }
`;

const SlideData = styled.div`
  position: absolute;
  bottom: 30px;
  left: 20px;
  width: 400px;
  z-index: 1;

  & h3 {
    color: #f7f7f7;
    font-family: AvenirBold;
    font-size: 32px;
    letter-spacing: -0.15px;

    @media (max-width: 767px) {
      color: #f7f7f7;
      font-family: AvenirBold;
      font-size: 28px;
      font-weight: 900;
      text-align: center;
    }
  }
  & p {
    color: #f7f7f7;
    letter-spacing: -0.15px;
    line-height: 1.3;
    font-size: 1.4em;
    text-align: left;
    opacity: 1;
    font-family: Avenir;
    text-align: justify;
  }
`;

const Title = styled.p`
  color: #1d1d1d;
  font-family: AvenirBold;
  font-size: 44px;
  font-weight: 900;
  letter-spacing: -0.15px;
  line-height: 60px;

  @media (max-width: 767px) {
    color: #1d1d1d;
    font-family: AvenirBold;
    font-size: 28px;
    font-weight: 900;
    line-height: 48px;
    text-align: center;
  }
`;

const SliderImageGradient = styled.div`
  position: relative;
  display: inline-block;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    background: linear-gradient(
      to bottom,
      rgba(0, 47, 75, 0.5) 0%,
      rgba(220, 66, 37, 0.5) 100%
    ); /* W3C */
  }
`;

const SlideWrapper = styled.div`
  border-radius: 20px;
  width: 100%;
  margin-right: 40px;
  height: auto;
  position: relative;
`;

const SliderImage = styled(ImageLazyLoad)`
  border-radius: 20px;
  width: 100%;
  margin-right: 40px;
  height: auto;
  position: relative;
  display: inline-block;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    background: linear-gradient(45deg, rgba(29, 29, 29, 0.95) 13%, rgba(29, 29, 29, 0) 100%);
  }

  & img {
    display: block;
  }
`;

const SliderWrapper = styled.div`
  width: 100%;
  height: 100%;
  perspective: 1000;
`;

const SmallSpacerDiv = styled.div`
  height: 30px;
  display: none;

  @media (min-width: 1200px) {
    display: block;
  }
`;

const NewParallaxSlider = ({ data }) => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `#featured-products-slider`,
        pin: true,
        start: 'center center',
        end: `+=${data.length * 100}%`,
        scrub: 1,
        reverse: true,
      },
    });

    for (let dataIndex = 1; dataIndex < data.length; dataIndex++) {
      tl.to('#new-parallax-slider', {
        x: `-=${100 / data.length}%`,
        ease: 'Power4.easeOut',
        delay: 1,
        stagger: 1,
        transformOrigin: 'center center',
      });
    }
  }, []);

  return (
    <SliderWrapper id='featured-products-slider' className='container'>
      <Title>Our great explorations...</Title>
      <SmallSpacerDiv />
      <div
        id='new-parallax-slider'
        style={{ width: `${data.length * 100}%`, display: 'inline-flex', flexWrap: 'no-wrap' }}>
        {data.map(({ url, text, description }) => (
          <SlideWrapper>
            <SlideData>
              <h3>{text}</h3>
              <p>{description}</p>
            </SlideData>
            <SliderImage src={url} />
          </SlideWrapper>
        ))}
      </div>
    </SliderWrapper>
  );
};

export { NewParallaxSlider };
